import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import Hero from "../components/trainers/Hero";
import Features from "../components/trainers/Features";
import Menu from "../components/trainers/Menu";
import HowItWorks from "../components/trainers/HowItWorks";
import Comparison from "../components/trainers/Comparison";
import Demo from "../components/trainers/Demo";
import Examples from "../components/trainers/Examples";
import Pricing from "../components/trainers/Pricing";
import Contact from "../components/trainers/Contact";
import Footer from "../components/trainers/Footer";

const Trainers = () => {
	const { t } = useTranslation();

	return (
		<>
			<Helmet>
				<title>{t("seo.trainers.title")}</title>
				<meta name="description" content={t("seo.trainers.description")} />
				<meta name="keywords" content={t("seo.trainers.keywords")} />
				<link rel="canonical" href="https://applaby.com/entrenadores" />

				<meta property="og:title" content={t("seo.trainers.ogTitle")} />
				<meta
					property="og:description"
					content={t("seo.trainers.ogDescription")}
				/>
				<meta
					property="og:image"
					content="https://applaby.com/assets/trainers/trainers-preview.png"
				/>
				<meta property="og:url" content="https://applaby.com/entrenadores" />
				<meta property="og:type" content="website" />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content={t("seo.trainers.twitterTitle")} />
				<meta
					name="twitter:description"
					content={t("seo.trainers.twitterDescription")}
				/>
				<meta
					name="twitter:image"
					content="https://applaby.com/assets/trainers/trainers-preview.png"
				/>
			</Helmet>

			<Menu />
			<Hero />
			<Features />
			<HowItWorks />
			<Demo />
			<Comparison />
			<Examples />
			<Pricing />
			<Contact />
			<Footer />
		</>
	);
};

export default Trainers;
